import { Component } from '@angular/core';

@Component({
    selector: 'footer-lora',
    templateUrl: 'footer.template.html',
    styleUrls: ['footer.style.scss']
})
export class FooterComponent { }



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/MZoVYbaM/0/has-gas/lora-wan/lora-ui/src/app/components/footer/footer.component.ts